import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Config } from "src/constants";
import { _ } from "src/services";
import { Modals, ModalsAction, ProfileData, ProfileDataAction } from "src/store";
import { Loading } from "../ui";
import { Modal } from "./modal";

export const DeviceAccessModal: React.FC = () => {

    //#region dependencies

    const dispatch = useDispatch();
    const modals: Modals = useSelector((state: any) => state.ModalsState);
    const user: ProfileData = useSelector((state: any) => state.ProfileDataState);

    //#end region

    //#region properties

    const timer = useRef<NodeJS.Timeout | null>(null);

    //#end region

    //#region states

    const [countDown, setCountDown] = useState(-1);
    const [verificationCode, setVerificationCode] = useState("");

    //#end region

    //#region methods

    const reSend = () => {
        setTimeout(() => {
            if (user.deviceToTerminate.seningRequest || user.deviceToTerminate.sendingSms) return;
            setVerificationCode("");
            dispatch(ProfileDataAction.sendDeviceCode(user.deviceToTerminate.currentDevice, user.deviceToTerminate.onSuccessCallback));
        });
    };

    const clearIntervals = () => {
        try {
            if (timer.current) clearInterval(timer.current);
        }
        catch { }
    };

    const onVerificationCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setVerificationCode(value);
    };

    const handlePhoneKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            countDown > 0 ? verifyCode() : reSend();
        }
    };

    const verifyCode = (e?: React.MouseEvent<HTMLButtonElement>) => {

        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (!verificationCode || !verificationCode.trim() || verificationCode.length < Config.lengthCode) {
            toast.error(_("verificationError"));
            return;
        }

        setTimeout(() => {
            if (user.deviceToTerminate.seningRequest) return;
            if (user?.deviceToTerminate?.currentDevice) {
                dispatch(ProfileDataAction.connectCurrentConfirmCode(verificationCode));
            }
            else {
                dispatch(ProfileDataAction.cutAllConfirmCode(verificationCode));
            }
        });
    };


    const onShow = () => setCountDown(-1);

    const onClose = () => {
        clearIntervals();
        setVerificationCode("");
        dispatch(ModalsAction.hideDeviceAccess());
        dispatch(ProfileDataAction.clearAccessCode());
    };

    //#end region

    //#region effects

    useEffect(() => {

        if (modals.deviceAccess && !user.deviceToTerminate.sendingSms && user.deviceToTerminate.seconds) {

            setCountDown(user.deviceToTerminate.seconds);
            setVerificationCode("");

            clearIntervals();

            timer.current = setInterval(() => {

                setCountDown((c) => {
                    if (c <= 1) clearIntervals();
                    return (c > 0 ? c - 1 : 0);
                });

            }, 1000);

        }

        return (() => {
            clearIntervals();
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.deviceToTerminate.sendingSms, user.deviceToTerminate.seconds, modals.deviceAccess]);

    //#end region

    //#region helpers

    const renderFooter = () => {

        if (user.deviceToTerminate?.sendingSms) return null;

        if (countDown > 0) {
            return (
                <>
                    <div className="col-xs-12 col-sm-5 order-1 order-sm-0">
                        <button tabIndex={0} className="w-100 btn btn-md btn-submit text-rtl" onClick={verifyCode}
                            disabled={!verificationCode}>
                            {!user.deviceToTerminate.seningRequest && <span>{_("verifyOTP")}</span>}
                            {user.deviceToTerminate.seningRequest && <Loading width={30} height={30} />}
                        </button>
                    </div>
                    <div className="col-xs-12 col-sm-7 text-sm-right text-center py-2 order-0 order-sm-1 pb-4 pb-sm-2">
                        <span className="text-timer">
                            {_("resendOTPAfter")} {countDown}
                        </span>
                    </div>
                </>
            );
        }

        return (
            <div className="col-xs-12 col-sm-5 order-1 order-sm-0">
                <button tabIndex={0} className="w-100 btn btn-md btn-submit text-rtl" onClick={reSend}>
                    <span>{_("resendOTP")}</span>
                </button>
            </div>
        );

    };

    const renderBody = () => {

        if (user.deviceToTerminate?.sendingSms) return (
            <Loading />
        );


        return (
            <>
                {
                    user.deviceToTerminate.message.split("\\n").map((x, i) => (
                        <p className="rtl" key={i}>{x}</p>
                    ))
                }
                <div className="form-group">
                    <div className="row justify-content-center">
                        <div className="col-xs-12 col-md-6">
                            <input
                                className="text-center form-control"
                                onKeyPress={handlePhoneKeyPress}
                                value={verificationCode}
                                onChange={onVerificationCodeChange}
                                autoFocus
                                type="tel"
                                maxLength={5}
                            />
                        </div>
                    </div>
                </div>
            </>
        );


    };

    //#end region

    const title = user.deviceToTerminate.currentDevice ? "restoreAccess" : "terminateAllAccesses";

    return (
        <Modal title={_(title)} show={modals.deviceAccess} renderFooter={renderFooter} onClose={onClose} onShow={onShow} className="modal-component--login ltr">
            <div className="content text-center">
                {renderBody()}
            </div>
        </Modal>
    );

};